import QueryTransaction from '@interfaces/transaction';
import { get, patch } from './api.service';
import { URL_REDEMPTIONS } from '@constants/api.constants';
import { getMsalInstance } from '@/auth/msalInstance';
import { UserType } from '@/state/interface';
import { IRedemption } from '@interfaces/redemption';
import { isWithinLastMinutes } from '@helpers/date-time.helper';
import { DateTime } from 'luxon';
import { RECENT_TXN_LIMIT_MIN } from '@constants/transaction.constants';
import { AxiosResponse } from 'axios';

export const getRedemptions = async (query: QueryTransaction) => {
		const msalInstance = await getMsalInstance();
		const params = { ...query };
		const user = msalInstance.getActiveAccount()?.idTokenClaims;
		const router = {
			OUTLET: 'by-outlet',
			POS: 'by-pos',
		};
		return get(`${URL_REDEMPTIONS}/${router[user?.extension_entity_type as UserType]}/${user?.extension_entity_id as string}`, { params }).then((res) => {
			res.data = res.data.map((redemption: IRedemption) => ({
				...redemption,
				isNew: isWithinLastMinutes(DateTime.fromISO(redemption.redeemDate), RECENT_TXN_LIMIT_MIN),
			}));
			return res;
	});
};

export const getRedemptionById = ({ id, redemptionType }: { id: string; redemptionType: string }) => {
	return get(`${URL_REDEMPTIONS}/${id}?redemptionType=${redemptionType}`);
};

export const updateRedemptionRefIdById = async ({ id, redemptionType, refId }: { id: string; redemptionType: string; refId: string }) => {
	const endpoint = `${URL_REDEMPTIONS}/${id}?redemptionType=${redemptionType}`;
	return (await patch(endpoint, { refId })) as AxiosResponse & { status: string; code?: string };
};
